// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const defineKey = (key: string, _value?: string) => key;
